/** Back-office › Espaces (30/10/2026) : paramètres d'URL de la liste et de l'export. */

export type EtatEspace = 'actifs' | 'fermes' | 'tous';

/** Paramètres d'URL de la liste et de l'export. */
export function parametres(f: {
  q: string;
  etat: EtatEspace;
  formule: string;
  page?: number;
}): string {
  const p = new URLSearchParams();
  if (f.q.trim()) p.set('q', f.q.trim());
  if (f.etat !== 'actifs') p.set('etat', f.etat);
  if (f.formule) p.set('formule', f.formule);
  if (f.page && f.page > 1) p.set('page', String(f.page));
  const texte = p.toString();
  return texte ? `?${texte}` : '';
}
